<app-dialog-header [title]="'general.api_image_editor_title'" [tooltip]="'general.api_image_editor_hint'"></app-dialog-header>
<mat-dialog-content class="with-footer">
  <ng-container *ngIf="multipleRatios">
    <mat-tab-group class="max-width" [(selectedIndex)]="activeTabIndex" (selectedIndexChange)="switchTab($event)">
      <mat-tab *ngFor="let ratio of S3UploaderRatioValues">
        <ng-template mat-tab-label>
          <div class="flex flex-column-mobile decreased-row-gap">
            <div [ngClass]="{'align-left': !utilService.isMobile}">{{ 'general.api_image_editor_ratio' | translate }} {{ ratio.replace('x', ':') }}</div>
            <div class="normal" [ngClass]="{'align-right': !utilService.isMobile, 'text-success': imagesOutput[ratio], 'text-warning': !imagesOutput[ratio]}">
              <mat-icon class="valign-middle svg-icon " [svgIcon]="imagesOutput[ratio] ? 'success' : 'warning'"></mat-icon>
              {{ 'general.api_image_editor_ratio_' + (imagesOutput[ratio] ? 'confirmed' : 'pending') | translate }}
            </div>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <div *ngIf="resize">
      <mat-checkbox [(ngModel)]="usePrimaryImage" [ngModelOptions]="{standalone: true}" (ngModelChange)="loadedImage = ''; switchRatio(ratioEnum)">
        {{ 'general.api_image_editor_multiple_ratios_use_primary_image_for_resizing' | translate }}
      </mat-checkbox>
    </div>
    <div class="text-muted bottom-spacer">{{ 'general.api_image_editor_multiple_ratios_hint_' + ratioEnum | translate }}</div>
  </ng-container>

  <div class="cropper-wrapper">
    <image-cropper
      *ngIf="loadedImage"
      [imageBase64]="loadedImage"
      [maintainAspectRatio]="maintainAspectRatio"
      [aspectRatio]="cropperRatio"
      [cropperMaxWidth]="cropperMaxWidth"
      [cropperMaxHeight]="cropperMaxHeight"
      [cropperMinWidth]="cropperMinWidth"
      [cropperMinHeight]="cropperMinHeight"
      [maxSize]="maxSize"
      [containWithinAspectRatio]="containWithinAspectRatio"
      [resetCropOnAspectRatioChange]="resetCropOnAspectRatioChange"
      [cropper]="cropperPosition"
      [transform]="transform"
      [resizeToWidth]="resizeToWidth"
      [imageQuality]="99.9"
      [onlyScaleDown]="true"
      [format]="'webp'"
      [output]="'blob'"
      (cropperReady)="resetImage()"
      (imageLoaded)="isLoading = false"
      (imageCropped)="imageCropped($event)"
      (loadImageFailed)="imageLoadFailed()"
    ></image-cropper>
  </div>

  <div class="fake-position">
    <image-cropper
      *ngIf="thumbSource"
      [imageBase64]="thumbSource"
      [maintainAspectRatio]="true"
      [aspectRatio]="thumbSize.width / thumbSize.height"
      [containWithinAspectRatio]="true"
      [resetCropOnAspectRatioChange]="true"
      [resizeToWidth]="thumbSize.width"
      [resizeToHeight]="thumbSize.height"
      [maxSize]="thumbSize"
      [imageQuality]="70"
      [onlyScaleDown]="true"
      [format]="'webp'"
      [output]="'blob'"
      (imageCropped)="thumbCropped($event)"
    ></image-cropper>
  </div>

  <app-loader class="top-spacer bottom-spacer" [loading]="isLoading" [size]="128"></app-loader>
  <div class="align-center top-spacer" *ngIf="!isLoading">
    <button mat-button class="icon-button input-button" [disabled]="cropperScale >= 4" (click)="zoomIn()">
      <mat-icon class="svg-icon" [svgIcon]="'plus'"></mat-icon>
    </button>
    <button mat-button class="left-spacer icon-button input-button" [disabled]="cropperScale <= 1" (click)="zoomOut()">
      <mat-icon class="svg-icon" [svgIcon]="'minus'"></mat-icon>
    </button>
    <button mat-button class="left-spacer icon-button input-button" (click)="resetImage()">
      <mat-icon class="svg-icon" [svgIcon]="'focus'"></mat-icon>
    </button>
  </div>
</mat-dialog-content>
<app-dialog-footer [dialogActions]="buttons"></app-dialog-footer>
<ng-template #buttons>
  <div class="flex flex-end max-width flex-mobile">
    <div class="flex-mobile">
      <button mat-button (click)="close()">{{ 'general.api_general_close' | translate }}</button>
      <button mat-stroked-button color="primary" *ngIf="multipleRatios && resize" (click)="saveOnlyCurrent()"
              [disabled]="!imagesOutput[ratioEnum] || !isChanged">
        {{ 'general.api_image_editor_button_save_current' | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="save()" [disabled]="!isValid || (resize && !isChanged)">
        {{ 'general.api_image_editor_button_ok' | translate }}
      </button>
    </div>
  </div>
</ng-template>
